import { render } from "./pl35-gej.vue?vue&type=template&id=1d7b7126&scoped=true"
import script from "./pl35-gej.vue?vue&type=script&lang=js"
export * from "./pl35-gej.vue?vue&type=script&lang=js"

import "./pl35-gej.vue?vue&type=style&index=0&id=1d7b7126&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7b7126"]])

export default __exports__